import React from "react";
import lodash from "lodash";

const Anchor = (props) => {
	const modifiedProps = lodash.merge({}, props, {
		href: props.href ? props.href : "javascript:void(0);"
	});
	return <a {...modifiedProps}>{modifiedProps.children}</a>;
};

export default Anchor;
